import { render, staticRenderFns } from "./peoplelist.vue?vue&type=template&id=2c1f5e10&scoped=true"
import script from "./peoplelist.vue?vue&type=script&lang=js"
export * from "./peoplelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f5e10",
  null
  
)

export default component.exports